import React from "react";
import { getAuth, signOut } from "firebase/auth";
import "./NavBar.css";
import Footprints from "../../Images/footprints-11.jpg";
import home from "../../Images/home.svg";
import news from "../../Images/news.jpg";
import trending from "../../Images/trending.jpg";
import groups from "../../Images/groups.svg";
import problems from "../../Images/questions.jpg";
import add from "../../Images/add.jpg";
import messenger from "../../Images/messenger.jpg";
import notify from "../../Images/notify.jpg";
import ItayAvatar from "../../Images/Fred3.jpg";
import UserAvatar from "../../Images/photoURL.png";
import skunk from "../../Images/skunk.jpg";
import About from "../../Images/About-2.png";
import logout from "../../Images/logout.png";
import { useNavigate } from "react-router-dom";
import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";

var bodyStyles = document.body.style;
bodyStyles.setProperty("--about-display", "none");
const photoURL = localStorage.getItem("myPicture");

//console.log("in left side and photoURL = ", photoURL);

//Now to get the userProfile from firebase so we can extract the profile picture
//we need to pass the userUID to a function and get the userProfile in return
const photoRef = UpdateUserPhotoURL(photoURL);
console.log("in nav bar after UpdateUserPhotoURL and photoURL = ", photoRef);
const handleAboutClick = (event: React.MouseEvent<HTMLElement>) => {
  console.log("Clicked!");
  bodyStyles.setProperty("--about-display", "block");
};
const loggedOut = 0;
const HandleLogoutClick = (event: React.MouseEvent<HTMLElement>) => {
  console.log("Clicked logout!");
  const auth = getAuth();
  signOut(auth)
    .then(() => {
      // Sign-out successful.
      console.log("Signed out successfully");
      window.location.assign("../");
    })
    .catch((error: any) => {
      // An error happened
      console.log(error);
      console.log("Signed out unsuccessful");
    });
};

function NavBar() {
  return (
    <div className="navbar_main">
      <div className="navbar_left">
        <img className="navbar_logo" src={Footprints} width="85px" />
        <input
          className="navbar_search"
          type="text"
          placeholder="Search footprints"
        />
      </div>
      <div className="navbar_container">
        <div className="navbar_tabs_small"></div>
        <div className="navbar_tabs">
          <img
            src={About}
            height="30px"
            width="30px"
            onClick={handleAboutClick}
            title="About Us"
          />
        </div>
        <div className="navbar_tabs">
          <img src={home} height="30px" width="30px" title="Home" />
        </div>
        <div className="navbar_tabs">
          <img src={news} height="29px" width="29px" title="News" />
        </div>
        <div className="navbar_tabs">
          <img src={trending} height="29px" width="29px" title="Trending" />
        </div>
        <div className="navbar_tabs">
          <img
            src={problems}
            height="30px"
            width="30px"
            title="Problem Resolution"
          />
        </div>
        <div className="navbar_tabs">
          <img src={skunk} height="31px" width="31px" title="Skunk Works" />
        </div>
        <div className="navbar_tabs_small"></div>
      </div>
      <div className="navbar_right">
        <div className="navbar_righttab">
          <img className="avatar" src={add} title="Add New" />
          <img className="avatar" src={messenger} title="Messaging" />
          <img className="avatar" src={notify} title="Notificiations" />
          <img
            className="avatar"
            src={logout}
            onClick={HandleLogoutClick}
            title="Logout"
          />
          <img className="avatar2" src={photoRef} title="My Profile" />
        </div>
      </div>
    </div>
  );
}

export default NavBar;
